import { useFlags, useFlagsmith } from "flagsmith/react";
import mixpanel from "mixpanel-browser";
import React, { createContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { onecodeAPI } from "./AppConfig";
import Loader from "./Components/Loader";
import { customerActions } from "./store/customerSlice";

const FeatureFlagContext = createContext();

const FeatureFlagProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { Provider } = FeatureFlagContext;

  const [id, setId] = React.useState("");
  const [hash, setHash] = React.useState();
  const [oneCode, setOneCode] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const flagsmith = useFlagsmith();
  const flags = useFlags([
    "black_listed_brands",
    "scb_cc_brand",
    "bank_name_field",
  ]);

  useEffect(() => {
    try {
      let params = new URLSearchParams(window.location.search);

      if (params.get("hash")) {
        setHash(encodeURIComponent(params.get("hash")));
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAgentDetails = async () => {
    try {
      setLoading(true);
      const res = await onecodeAPI.post("public/customer/getAgentDetails", {
        hash: hash,
      });
      // console.log("agent details response", res);
      const {
        data: {
          result: { onecodeId, onecode, phoneNumber },
        },
      } = res;
      setId(onecodeId);
      setOneCode(onecode);
      mixpanel.identify(onecodeId ?? phoneNumber);
      dispatch(customerActions.setPartnerFormLoading(false));
      // openLinkRedirection(onecodeId);
    } catch (e) {
      console.log("error fetching data", e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const openLinkRedirection = (id) => {
    let whiteListedUser = [
      1887487, 1893428, 131568, 1089136, 129482, 728654, 568548, 537483,
      1624144, 1550850, 1637426, 1242965, 979610, 1639435, 1117980, 790128,
      1540508, 1538143, 1388511, 1274790, 1072551, 1172309, 799828, 26732,
      1558479, 496083, 8174, 218348, 1583214, 926425, 1561358, 1556389, 160445,
      428813, 1333604, 1290368, 463747, 1682335, 324743, 1573173, 1572610,
      1384405, 1285710, 983304, 51941, 37676, 879543, 1661193, 1004945, 1629716,
      1539648, 544865, 1435285, 435458, 1607571, 1498490, 1540886, 1557941,
      1307278, 1111527, 1269134, 1080784, 1060620, 1666956, 1452077, 1438084,
      1117519, 1544876, 1577954, 1591665, 1516929, 426353, 52447, 1573170,
      1029165, 1612565, 1554656, 1558798, 874481, 392071, 1331316, 1560671,
      1519885, 172716, 1614983, 49878, 1690935, 1577050, 63363, 1600364, 915730,
      1636291, 1369592, 747285, 1586406, 328129, 1595248, 1115784, 1384462,
      1434353, 1669842, 1660622, 1493200, 1231255, 663108, 1215026, 1600074,
      1479488, 1539134, 1355413, 169479, 611910, 1646047, 1411444, 1404377,
      1668238, 1305964, 248804, 1383903, 1554517, 1518754, 658740, 1614004,
      1276619, 523183, 1533759, 752894, 1622665, 1600647, 1631863, 1561349,
      1579493, 1626733, 1615317, 1624448, 51976, 1639493, 1560839, 868837,
      687824, 939349, 1333270, 533740, 1524663, 1384056, 1447440, 426360,
      1669487, 1667729, 1667698, 1670566, 1677268, 1666101, 1667255, 1667860,
      1671353, 1670357, 1671726, 1678353, 1678532, 1680301, 1682700, 1696138,
      1699573, 1698926, 1705196, 1706043, 1706447, 1701921, 1702613, 1702550,
      1707272, 1709365, 1708605, 1710487, 1708776, 1694008, 1693914, 1711504,
      1591839, 1558105, 1589061, 1575997, 394014, 978688, 1555660, 1643739,
      1568910, 244783, 1429042, 241462, 1618900, 1568986, 1617521, 1385407,
      1465733, 1596231, 1573222, 1652330, 1547464, 1618292, 1524109, 1609123,
      1557770, 1636667, 1625745, 498796, 1576923, 1578018, 1556413, 1563088,
      1041849, 1576088, 1577933, 1618926, 1619330, 1618280, 1616552, 1615107,
      1630752, 1642759, 322890, 1531858, 163696, 151948, 1514644, 1595338,
      181940, 1656750, 1644599, 1631539, 1370689, 1722238, 1382930, 1727519,
      1705612, 986944, 1715145, 1666472, 1461787, 1616909, 1642620, 469242,
      1601178, 1518203, 1612203, 934741, 1698636, 1565261, 1716136, 5, 1718600,
      1719678, 1735228, 1734678, 1734415, 1723819, 1723729, 1740002, 362647,
      572107, 1741999, 1739062, 1434139, 1622649, 1739698, 1746686, 1718565,
      1749402, 1453839, 1701184, 1572420, 1731505, 812344, 1369611, 1325581,
      1588897, 1602896, 1720106, 1358673, 1098537, 1655472, 958178, 1606026,
      1706144, 408641, 1656516, 1758495, 1762746, 1375364, 1546819, 1705706,
      1648125, 1715856, 1759481, 289820, 1766565, 1488736, 1765753, 1764718,
      1772943, 1774187, 1777235, 712983, 1780112, 1270094, 1786645, 41642,
      135638, 1231590, 245513, 565772, 1798456, 1794994, 1553619, 1666212,
      1543251, 1566617, 1648271, 1728956, 1798651, 1476387, 1504474, 1707577,
      1805372, 1805456, 1721387, 807630, 1357212, 1740978, 1740962, 1740982,
      1740983, 1740984, 1740985, 1740986, 1740987, 1740988, 1740989, 1740990,
      1740991, 1810301, 1807911, 1816141, 1815846, 1812146, 1815720, 1157526,
      1817392, 1819108, 1655977, 1818898, 1784802, 1235194, 1236356, 1825116,
      1826407, 1827930, 1834610, 1670832, 1572008, 1835640, 1611862, 1840100,
      1520259, 1744167, 1568819, 1831442, 1562285, 1776619, 1657907, 1720532,
      1572201, 1584392, 1380588, 1552977, 1692703, 899845, 1380608, 1493828,
      1682374, 177690, 158133, 187000, 1834904, 1718844, 1578587, 1762199,
      1726170, 1715311, 1712620, 1750238, 1844267, 880778, 1248205, 549595,
      1702460, 1576298, 1691512, 235858, 1659292, 1049798, 465286, 1777042,
      1533716, 1851771, 1700988, 1570535, 1827545, 1798486, 1854014, 1849851,
      1117352, 1824818, 1854492, 1762217, 1861486, 1762217, 1863538, 1865148,
      1772892, 1773973, 1423139, 1874113, 1836956, 1868272, 83536, 1639069,
      1509472, 454490, 89590, 1032878, 1854785, 1866289, 1898841, 1899367,
      1899738, 1897836,
    ];

    if (!whiteListedUser.includes(id)) {
      if (window.location.pathname.includes("/v2/old")) {
        window.location.replace(
          `https://customer.zetapp.in/customer/login${window.location.search}`
        );
      }
    }
  };

  useEffect(() => {
    if (hash) {
      getAgentDetails();
    } else {
      setLoading(false);
    }
  }, [hash]);

  useEffect(() => {
    if (id) {
      flagsmith.identify(id);
    }
  }, [id]);

  if (loading) {
    return <Loader />;
  }

  return <Provider value={{ flags, oneCode }}>{children}</Provider>;
};

export { FeatureFlagContext, FeatureFlagProvider };
